<template>
  <v-card :loading="isLoading">
    <v-card-text v-if="companyId">
      <v-data-table
        v-bind="dataTableAttrs"
        :headers="headersShown"
        :items="list"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="total"
        :items-per-page.sync="itemsPerPage"
        v-model="selectedItems"
        @update:items-per-page="handleItemsPerPageUpdated"
      >
        <template v-slot:top>
          <rs-table-title-bar
            v-if="$refs.headSearch"
            title="Çalışan Görev Türleri"
            icon="mdi mdi-account-network"
            :add-route="
              can('add-company')
                ? { name: 'my-company.worker-positions.create' }
                : null
            "
            @clear-filters="$refs.headSearch.reset"
            @reload="loadList"
            :edit-enabled="selectedItems.length === 1"
            :search.sync="search.query"
            @click:edit="handleEditClick"
            :delete-enabled="selectedItems.length === 1"
            @click:delete="handleDeleteClick"
            :show-delete="can('delete-company')"
            :hide-edit="!can('edit-company')"
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:body.prepend="{ headers }">
          <rs-table-head-search
            :headers="headers"
            :search.sync="search"
            ref="headSearch"
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.edit="{ item }">
          <router-link
            class="btn btn-icon btn-sm btn-clean"
            :to="{
              name: 'my-company.worker-positions.edit',
              params: { id: item.id },
            }"
          >
            <i class="menu-icon mdi mdi-pencil"></i>
          </router-link>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.name="{ item }">
          <router-link
            :to="{
              name: 'my-company.worker-positions.show',
              params: { id: item.id },
            }"
          >
            {{ item.name }}
          </router-link>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.is_active="{ value }">
          <rs-table-cell-boolean :value="value" />
        </template>
      </v-data-table>

      <rs-confirm
        ref="confirmDelete"
        :loading="isLoading"
        @confirmed="handleDeleteConfirmed"
        @cancelled="$refs.confirmDelete.hide()"
      />
    </v-card-text>
    <v-card-text v-else>
      Listeyi görmek için üst menüden bir yönetim şirketi seçin.
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

import { debounce } from "@/core/plugins/debounce";
import CompanyService from "@/core/services/company.service";
import { hasDataTable, hasPermissions } from "@/view/mixins";

export default {
  mixins: [hasDataTable, hasPermissions],
  computed: {
    ...mapGetters(["companyId"]),
  },
  watch: {
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
    search: {
      handler: debounce(function () {
        this.loadList();
      }),
      deep: true,
    },
    companyId: {
      handler() {
        this.loadList();
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: "",
          value: "edit",
          searchable: false,
          sortable: false,
          width: "30px",
          align: "center",
          hide: () => !this.can("edit-company"),
        },
        {
          text: "Çalışan Görev Türü",
          value: "name",
          searchable: "text",
        },
        {
          text: this.$t("labels.status"),
          value: "is_active",
          searchable: "isActive",
          align: "center",
        },
      ],
    };
  },
  methods: {
    loadList() {
      if (this.isLoading || !this.companyId) {
        return;
      }

      this.isLoading = true;
      this.list = [];
      this.selectedItems = [];

      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      params.company_id = this.companyId;

      this.$api
        .query(`worker-positions/`, { params })
        .then((response) => {
          if (response.data && response.data.data) {
            this.list = response.data.data;
          }

          if (response.data && response.data.meta) {
            this.total = response.data.meta.total;
            this.options.page = response.data.meta.current_page;
            this.itemsPerPage = response.data.meta.per_page;
            this.options.itemsPerPage = this.itemsPerPage;
          }
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    handleEditClick() {
      if (this.selectedItems.length === 1) {
        this.$router.push({
          name: "my-company.worker-positions.edit",
          params: { id: this.selectedItems[0].id },
        });
      }
    },
    handleDelete() {
      this.$api
        .delete(`worker-positions/${this.selectedItems[0].id}`)
        .then(() => {
          this.$toast.success("Çalışan görev türü silindi.");
          CompanyService.getWorkerPositions();
          this.$nextTick(() => this.loadList());
        })
        .catch((error) => {
          this.handleError(error);
        });
    },
    handleDeleteClick() {
      this.$refs.confirmDelete.show(
        `${this.selectedItems[0].name} çalışan görev türünü silmek istediğinizden emin misiniz?`
      );
    },
    handleDeleteConfirmed() {
      this.handleDelete();
      this.$refs.confirmDelete.hide();
    },
  },
};
</script>
